import { Injectable } from "@angular/core";

declare global {
  interface Window {
    electronAPI?: {
      getFiles: () => Promise<{ name: string; path: string }[]>;
      readVideoChunks: (filePath: string) => void;
      onVideoChunk: (callback: (chunk: ArrayBuffer) => void) => void;
      onVideoChunkEnd: (callback: () => void) => void;
      onVideoChunkError: (callback: (error: string) => void) => void;
    };
  }
}

@Injectable({
  providedIn: "root",
})
export class ElectronService {
  constructor() {}

  getFiles() {
    return window.electronAPI?.getFiles() || Promise.resolve([]);
  }

  readVideoChunks(filePath: string) {
    window.electronAPI?.readVideoChunks(filePath);
  }

  onVideoChunk(callback: (chunk: ArrayBuffer) => void) {
    window.electronAPI?.onVideoChunk(callback);
  }

  onVideoChunkEnd(callback: () => void) {
    window.electronAPI?.onVideoChunkEnd(callback);
  }

  onVideoChunkError(callback: (error: string) => void) {
    window.electronAPI?.onVideoChunkError(callback);
  }
}
